(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    const root=document.documentElement;
const body=document.body;
const toggleClass=(selector,className,force)=>{const target=document.querySelector(selector);if(target)target.classList.toggle(className,force)};
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-action]');
  if(!button)return;
  const action=button.dataset.action;
  if(action==='toggle-search')toggleClass('#SearchPanel','is-open');
  if(action==='open-menu'){toggleClass('#MobileNav','is-open',true);body.classList.add('drawer-open')}
  if(action==='close-menu'){toggleClass('#MobileNav','is-open',false);body.classList.remove('drawer-open')}
  if(action==='open-cart'){toggleClass('#CartDrawer','is-open',true);body.classList.add('drawer-open')}
  if(action==='close-cart'){toggleClass('#CartDrawer','is-open',false);body.classList.remove('drawer-open')}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){toggleClass('#MobileNav','is-open',false);toggleClass('#CartDrawer','is-open',false);body.classList.remove('drawer-open')}});
document.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-ajax-cart-form]');
  if(!form)return;
  event.preventDefault();
  const submit=form.querySelector('[type="submit"]');
  if(submit)submit.disabled=true;
  try{
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    if(!response.ok)throw new Error('cart');
    window.location.href=window.Shopify.routes.root+'cart';
  }catch(error){form.submit()}
});
document.querySelectorAll('[data-variant-select]').forEach(select=>{
  select.addEventListener('change',()=>{
    const option=select.options[select.selectedIndex];
    const form=select.closest('form');
    const button=form&&form.querySelector('[type="submit"]');
    const price=document.querySelector('[data-product-price]');
    if(button){button.disabled=option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?button.dataset.addText:button.dataset.soldText}
    if(price&&option.dataset.price)price.textContent=option.dataset.price;
    const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);
  });
});
const prefersReduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealEls=document.querySelectorAll('.reveal,.reveal-left,.reveal-scale');
if(prefersReduced||!('IntersectionObserver'in window)){
  revealEls.forEach(el=>el.classList.add('is-visible'));
}else{
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}});
  },{threshold:0.12,rootMargin:'0px 0px -8% 0px'});
  revealEls.forEach(el=>io.observe(el));
}
root.classList.add('js');

/* Design 2026 : effet 3D au survol (tilt) */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if(reduce||!finePointer)return;
  var MAX=7;
  function bindTilt(el){
    if(!el||el.dataset.tiltBound)return;el.dataset.tiltBound='1';el.classList.add('card-3d');
    el.addEventListener('pointermove',function(e){
      var r=el.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width-0.5;
      var py=(e.clientY-r.top)/r.height-0.5;
      el.style.setProperty('--ry',(px*MAX).toFixed(2)+'deg');
      el.style.setProperty('--rx',(-py*MAX).toFixed(2)+'deg');
      el.classList.add('is-tilting');
    });
    el.addEventListener('pointerleave',function(){
      el.style.setProperty('--ry','0deg');el.style.setProperty('--rx','0deg');
      el.classList.remove('is-tilting');
    });
  }
  function initTilt(){
    document.querySelectorAll('.category-card').forEach(function(c){c.classList.add('shine');bindTilt(c);});
    document.querySelectorAll('.product-card__media').forEach(function(m){m.classList.add('shine');bindTilt(m);});
  }
  if(document.readyState!=='loading')initTilt();else document.addEventListener('DOMContentLoaded',initTilt);
})();

/* OmniForYou audit fixes 2026-07-19: mobile menu a11y + product gallery. */
(function(){
  function qs(s,c){return(c||document).querySelector(s)}
    function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
      function setMenu(open){
          var nav=qs('#MobileNav'); if(!nav)return;
              nav.classList.toggle('is-open',!!open); document.body.classList.toggle('drawer-open',!!open);
                  qsa('[data-action="open-menu"],[aria-controls="MobileNav"]').forEach(function(b){b.setAttribute('aria-expanded',open?'true':'false')});
                      if(open){var f=nav.querySelector('a,button,input,[tabindex]:not([tabindex="-1"])'); if(f)f.focus();}
                        }
                          document.addEventListener('click',function(e){
                              if(e.target.closest('[data-action="open-menu"],[aria-controls="MobileNav"]')){e.preventDefault();setMenu(true)}
                                  if(e.target.closest('[data-action="close-menu"]')){e.preventDefault();setMenu(false)}
                                      if(document.body.classList.contains('drawer-open')&&!e.target.closest('#MobileNav')&&!e.target.closest('[data-action="open-menu"],[aria-controls="MobileNav"]'))setMenu(false);
                                        });
                                          document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false)});
                                            qsa('.product-gallery').forEach(function(g){
                                                var items=qsa('.pg-item',g),thumbs=qsa('.pg-thumb',g),i=Math.max(0,items.findIndex(function(x){return x.classList.contains('is-active')}));
                                                    function show(n){if(!items.length)return;i=(n+items.length)%items.length;items.forEach(function(x,k){x.classList.toggle('is-active',k===i)});thumbs.forEach(function(x,k){x.classList.toggle('is-active',k===i);x.setAttribute('aria-current',k===i?'true':'false')})}
                                                        g.addEventListener('click',function(e){var t=e.target.closest('[data-gallery-thumb]');if(t){show(thumbs.indexOf(t));return}if(e.target.closest('[data-gallery-prev]'))show(i-1);if(e.target.closest('[data-gallery-next]'))show(i+1)});
                                                            var sx=0;g.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});g.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>45)show(i+(dx<0?1:-1))},{passive:true});show(i);
                                                              });
                                                              })();
                                                              /* End OmniForYou audit fixes 2026-07-19. */
  } catch(e) { console.error(e); }
})();

})();
